/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */

import SomethingWentWrongImage from "assets/something-wrong-title.png";
import Image from "components/ui/Image";

const SomethingWrong = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen -bg--theme-colors-surface-neutral-level00 -text--theme-colors-icon-brand-02">
      <Image
        src={SomethingWentWrongImage}
        alt="something went wrong"
        className="w-64"
      />

      <div className="flex gap-1 flex-col justify-center items-center text-center mt-8">
        <span className="text-white normal-case text-xl font-bold">
          Something Went Wrong
        </span>

        <div>
          <span className="text-sm text-[#989898] ">
            It seems there was an issue please try again later.
          </span>

          <span className="flex gap-1 text-sm text-[#989898] justify-center items-center text-center">
            Please
            <a href="/" className="underline">
              contact support.
            </a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default SomethingWrong;
